module.exports = __webpack_public_path__ + "img/電気回路_6_1_3.24d80f74.png";